module.exports = __webpack_public_path__ + "img/34_46.5c92fd6d.png";